/**
 * Terms of Use content component
 */

export function TermsOfUse() {
  return (
    <ul className="custom-list">
      <p>
        Welcome to Picture Health.
        <br />
        <br />
        Please read on to learn the rules that govern your participation in a demonstration of our
        platform (the &quot;Px Platform&quot; or &quot;Platform&quot;) and submission of Images (as
        defined below). The Px Platform is being made available for Research Use Only
        (&quot;RUO&quot;). This Platform Demonstration Agreement (the &quot;Agreement&quot;) is a
        binding contract between you and Picture Health Inc. (&quot;Picture Health,&quot;
        &quot;we&quot; and &quot;us&quot;).
        <br />
        <br />
        By clicking the &quot;Accept&quot; button below, accessing or using the Px Platform or
        submitting any Images, you hereby agree to all terms and conditions of this Agreement.
        <br />
        <br />
        IF YOU ARE NOT AUTHORIZED TO ENTER INTO THIS AGREEMENT, OR IF YOU DO NOT AGREE TO ALL OF THE
        TERMS AND CONDITIONS HEREIN, YOU SHOULD CLICK ON THE &quot;DECLINE&quot; BUTTON BELOW AND
        YOU MUST NOT ACCESS OR USE THE PX PLATFORM OR SUBMIT ANY IMAGES.
      </p>
      <li>
        <strong>Demonstration</strong>
        <p>
          Subject to the terms and conditions of this Agreement, Picture Health grants you a
          limited, personal, non-sublicensable, non-exclusive license to participate in a
          demonstration of and evaluate the Px Platform and all outputs generated in connection with
          Picture Health&apos;s demonstration thereof (&quot;Outputs&quot;) solely for your internal
          research purposes. Picture Health and its licensors own and shall retain all right, title
          and interest in and to the Px Platform, including all modifications thereto. You agree
          that you will only access and use the Px Platform and Outputs in the ordinary course of
          your internal research. Without limiting the foregoing, you will not, directly or
          indirectly, use the Px Platform or Outputs for the benefit of any third party, for or in
          connection with any commercial purpose or for or in connection with any diagnosis,
          treatment or any other activity involving the provision of medical care or advice.
        </p>
      </li>
      <li>
        <strong>Image Submission</strong>
        <p>
          As part of and in preparation for the demonstration of the Px Platform, Picture Health
          will be accepting submissions of deidentified (as such term is defined by the Health
          Insurance Portability and Accountability Act of 1996, as amended from time to time
          (&quot;HIPAA&quot;)) pre-treatment CT scans of lung cancer patients (each such scan, an
          &quot;Image&quot;). By submitting any Image to Picture Health, you hereby grant Picture
          Health a limited, non-sublicensable, non-exclusive license to analyze the Image through
          the Px Platform and generate data solely in connection with and as needed to conduct this
          analysis.
        </p>
      </li>
      <li>
        <strong>Disclaimers</strong>
        <p>
          You acknowledge and agree that Picture Health provides the Px Platform and Outputs
          &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; without warranty of any kind, express or
          implied. Picture Health does not offer medical advice or diagnoses, or engage in the
          practice of medicine.
        </p>
      </li>
    </ul>
  );
}
